import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Row, Col, UncontrolledTooltip } from 'reactstrap';
import formatDistance from 'date-fns/formatDistance';
import format from 'date-fns/format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
// import selectors
import { selectRatingById } from 'redux/rating/selector';
// import APIs
import { rateUpAPI, removeRateAPI } from 'api/rating';
import { getJobDetailAPI } from 'api/job';
// import redux actions
import getListRatingAction from 'redux/rating/getListRatingAction';
import BannerImg from 'assets/images/banner.png';
import JobDetailLoading from './JobDetailLoading';
import './index.css';

const JobDetail = () => {
  const { jobId } = useParams();
  const { isAuthenticated, user } = useAuth0();
  const dispatch = useDispatch();
  const [jobInfo, setJobInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const ratingInfo = useSelector((state) =>
    selectRatingById(state)(jobInfo?.key)
  );

  useEffect(() => {
    const getJobDetail = async () => {
      try {
        if (!jobId) {
          setIsLoading(false);
          return;
        }
        const jobDetail = await getJobDetailAPI(jobId);
        setJobInfo(jobDetail);
        setIsLoading(false);
      } catch (ex) {
        console.log(ex);
        setIsLoading(false);
      }
    };

    setIsLoading(true);
    getJobDetail();
  }, [jobId]);

  const onSave = async () => {
    if (!ratingInfo?.rating || ratingInfo?.rating === -1) {
      await rateUpAPI(user?.email, jobId);
      return dispatch(getListRatingAction(user?.email));
    }

    await removeRateAPI(user?.email, jobId);
    return dispatch(getListRatingAction(user?.email));
  };

  const onApply = () => {
    window
      .open(jobInfo?.apply_url?.[0] || jobInfo?.apply_url, '_blank')
      .focus();
  };

  if (isLoading) return <JobDetailLoading />;
  return (
    <div className="job-detail-page">
      <div
        className="banner"
        style={{ backgroundImage: `url(${BannerImg})` }}
      />
      <div className="container info-section">
        <div className="header-section">
          <div className="logo">
            <img
              className="JobImage"
              alt=""
              src="data:image/jpeg;base64,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"
            />
          </div>
          <div className="header-info-section">
            <div className="title">{jobInfo?.title}</div>
            <div className="company">{jobInfo?.company_name}</div>
            <div className="time-expire">
              <FontAwesomeIcon icon={faCalendarAlt} />{' '}
              {jobInfo?.keep_until &&
                `Apply before ${format(
                  new Date(jobInfo?.keep_until * 1000),
                  'dd/MM/yyyy'
                )}`}
            </div>
            <div className="time-ago">
              {jobInfo?.updated_at &&
                formatDistance(
                  new Date(jobInfo.updated_at * 1000),
                  new Date(),
                  {
                    addSuffix: true,
                  }
                )}
            </div>
            <div className="action-section">
              {!isAuthenticated && (
                <>
                  <Button
                    id="save-btn"
                    className="save-btn"
                    color="primary"
                    size="lg"
                    outline
                  >
                    Save
                  </Button>
                  <UncontrolledTooltip placement="bottom" target="save-btn">
                    Please login to record your ratings
                  </UncontrolledTooltip>
                </>
              )}
              {isAuthenticated && (
                <Button
                  className="save-btn"
                  color="primary"
                  size="lg"
                  outline={ratingInfo?.rating === 1}
                  onClick={onSave}
                >
                  Save
                </Button>
              )}
              {jobInfo?.apply_url && (
                <Button onClick={onApply} color="primary" size="lg" outline>
                  Apply
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className="divide-section">
          <div className="img-offset" />
          <div className="content-offset">
            <Row>
              <Col sm="6 d-flex">
                <div className="time-ago-title">Posted:</div>
                <div className="time-ago">
                  {jobInfo?.updated_at &&
                    formatDistance(
                      new Date(jobInfo.updated_at * 1000),
                      new Date(),
                      {
                        addSuffix: true,
                      }
                    )}
                </div>
              </Col>
              <Col sm="6 d-flex">
                <div className="applied-number-title">Job Application:</div>
                <div className="applied-number">134</div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="job-info-section">
          <div className="section">
            <div className="title">
              <span>Job Description</span>
            </div>
            <div className="content d-flex">
              <div className="img-offset" />
              <div
                className="content-offset"
                dangerouslySetInnerHTML={{ __html: jobInfo?.desc }}
              />
            </div>
          </div>
          <div className="section">
            <div className="title">
              <span>Job Requirements</span>
            </div>
            <div className="content d-flex">
              <div className="img-offset" />
              <div className="content-offset">
                <p>Replace</p>
                <p>Replace</p>
                <p>Replace</p>
                <p>Replace</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetail;
